import { useZonedDateTime } from "../../../../../../../../components/global_components/ZonedDateTime";
import { GetNotifyNotificationContentSearchResponse } from "../../../../../../../../queries/notify";
import { formatDateFromNow } from "../../../../../../../../utils/functions";

export function NotifyNotificationsDates({
  content,
}: {
  content: GetNotifyNotificationContentSearchResponse["data"][number];
}) {
  const formattedPublishedAt = useZonedDateTime({
    value: content.publishedAt,
    formatString: "MMM d, yyyy",
    disableAutoTimezoneIndicator: true,
  });
  const formattedExpiredAt = useZonedDateTime({
    // TODO: I think this might be the wrong timestamp, but the right one doesn't exist yet...
    value: content.expiredAt,
    formatString: "MMM d, yyyy",
    disableAutoTimezoneIndicator: true,
  });

  const dateString = [
    content.status === "Draft" ? `Last edited ${formatDateFromNow(content.updatedAt)}` : null,
    formattedPublishedAt ? `Sent ${formattedPublishedAt}` : null,
    formattedExpiredAt ? `Expires ${formattedExpiredAt}` : null,
  ]
    .filter(Boolean) // Remove null values
    .join(" • ");

  return <span className='tw-font-semibold tw-text-text-hint'>{dateString}</span>;
}
